<template>
  <v-main>
    <v-container fluid>
      <!-- Reminder: unfinished purchase orders that were saved as drafts -->
      <div v-if="draftCount > 0" class="draft-banner mb-3">
        <span class="draft-banner__icon"><v-icon color="white" small>mdi-file-document-edit-outline</v-icon></span>
        <span class="draft-banner__text">
          <b>{{ draftCount }}</b> purchase order{{ draftCount === 1 ? " is" : "s are" }} in draft &mdash; please complete {{ draftCount === 1 ? "it" : "them" }}.
        </span>
        <v-spacer></v-spacer>
        <v-btn text small color="orange darken-3" @click="showDrafts">View drafts</v-btn>
      </div>

      <v-row>
        <v-col md="12">
          <v-card elevation="0" rounded="xxl" class="app-card">
            <v-card-title>
              <AppPageHeader
                icon="mdi-truck-delivery-outline"
                title="Purchase Orders"
                subtitle="Stock ordered in from vendors"
                style="width: 100%"
              >
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-bind="attrs"
                      v-on="on"
                      fab
                      x-small
                      color="primary"
                      @click="openCreate"
                    >
                      <v-icon dark> mdi-plus </v-icon>
                    </v-btn>
                  </template>
                  <span>Create Purchase Order</span>
                </v-tooltip>
              </AppPageHeader>
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col md="6">
                  <v-text-field
                    solo
                    rounded
                    v-model="filter.search_keyword"
                    label="Search PO # or Vendor... "
                    prepend-inner-icon="mdi-magnify"
                    clearable
                    @click:clear="
                      (filter.search_keyword = null), (page = 1), getData()
                    "
                    @keydown.enter="(page = 1), getData()"
                  ></v-text-field>
                </v-col>
                <v-col sm="3">
                  <v-autocomplete
                    solo
                    rounded
                    v-model="filter.vendor_id"
                    :items="vendors"
                    item-text="name"
                    item-value="id"
                    label="Vendor"
                    @input="(page = 1), getData()"
                    prepend-inner-icon="mdi-domain"
                    clearable
                  ></v-autocomplete>
                </v-col>
                <v-col sm="3">
                  <v-select
                    solo
                    rounded
                    v-model="filter.status"
                    :items="statusOptions"
                    item-text="text"
                    item-value="value"
                    label="Status"
                    prepend-inner-icon="mdi-filter-variant"
                    clearable
                    @input="(page = 1), getData()"
                  ></v-select>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <v-row>
        <v-col md="12">
          <v-card elevation="0" rounded="xxl" class="app-card">
            <v-card-text>
              <section v-if="isLoading" style="height: 285px">
                <v-progress-linear
                  indeterminate
                  color="primary"
                ></v-progress-linear>
              </section>
              <v-simple-table
                v-else
                fixed-header
                height="500"
                class="striped-table"
              >
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left">Sr No</th>
                      <th class="text-left">PO Number</th>
                      <th class="text-left">Vendor</th>
                      <th class="text-left">PO Date</th>
                      <th class="text-left">Expected Delivery</th>
                      <th class="text-right">Total</th>
                      <th class="text-left">Billing Status</th>
                      <th class="text-right">Payment Status</th>
                      <th class="text-right action_th">Action</th>
                    </tr>
                  </thead>
                  <tbody v-if="orders.length != 0">
                    <tr
                      v-for="(order, i) in orders"
                      :key="`po_${i}`"
                      class="clickable-row"
                      @click="order.is_draft ? openDraft(order) : viewOrder(order)"
                    >
                      <td style="min-width: 85px">{{ i + 1 }}</td>
                      <td>{{ order.po_number }}</td>
                      <td>{{ order.vendor ? order.vendor.name : "" }}</td>
                      <td>{{ $options.filters.niceDate(order.po_date) }}</td>
                      <td>{{ $options.filters.niceDate(order.expected_delivery_date) }}</td>
                      <td class="text-right mono-figure">{{ order.total_amount }}</td>
                      <td>
                        <v-chip v-if="order.is_draft" small color="orange" text-color="white">Draft</v-chip>
                        <v-chip
                          v-else
                          small
                          :color="billingStatusColor(order.billing_status)"
                          text-color="white"
                        >
                          {{ billingStatusLabels[order.billing_status] }}
                        </v-chip>
                      </td>
                      <td>
                        <span v-if="order.is_draft" class="grey--text">&mdash;</span>
                        <v-chip
                          v-else
                          small
                          :color="paymentStatusColor(order.payment_status)"
                          text-color="white"
                        >
                          {{ paymentStatusLabels[order.payment_status] }}
                        </v-chip>
                      </td>
                      <!-- <td class="text-right">
                        <v-tooltip bottom v-if="order.billing_status === 'unbilled'">
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              v-bind="attrs"
                              v-on="on"
                              fab
                              x-small
                              class="my-auto"
                              color="error"
                              @click="Delete_this(order.id)"
                            >
                              <v-icon dark> mdi-delete </v-icon>
                            </v-btn>
                          </template>
                          <span>Delete this purchase order</span>
                        </v-tooltip>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              v-bind="attrs"
                              v-on="on"
                              class="ml-2"
                              fab
                              x-small
                              color="primary"
                              :to="`/purchase-orders/${encryptIt(order.id)}`"
                            >
                              <v-icon dark>{{ order.billing_status === 'unbilled' ? 'mdi-pencil' : 'mdi-eye' }}</v-icon>
                            </v-btn>
                          </template>
                          <span>{{ order.billing_status === 'unbilled' ? 'Edit this purchase order' : 'View this purchase order' }}</span>
                        </v-tooltip>
                      </td> -->
                      <td v-if="order.is_draft" class="text-right action_th">
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              v-bind="attrs"
                              v-on="on"
                              fab
                              x-small
                              class="my-auto"
                              color="primary"
                              @click.stop="openDraft(order)"
                            >
                              <v-icon dark>mdi-pencil</v-icon>
                            </v-btn>
                          </template>
                          <span>Edit and complete this draft</span>
                        </v-tooltip>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              v-bind="attrs"
                              v-on="on"
                              class="ml-2 my-auto"
                              fab
                              x-small
                              color="error"
                              @click.stop="confirmDeleteDraft(order)"
                            >
                              <v-icon dark>mdi-delete</v-icon>
                            </v-btn>
                          </template>
                          <span>Delete this draft</span>
                        </v-tooltip>
                      </td>
                      <td v-else class="text-right action_th">
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              v-bind="attrs"
                              v-on="on"
                              fab
                              x-small
                              class="my-auto"
                              color="primary"
                              @click.stop="viewOrder(order)"
                            >
                              <v-icon dark>mdi-eye</v-icon>
                            </v-btn>
                          </template>
                          <span>View this purchase order</span>
                        </v-tooltip>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              v-bind="attrs"
                              v-on="on"
                              class="ml-2 my-auto"
                              fab
                              x-small
                              color="primary"
                              @click.stop="openEdit(order)"
                            >
                              <v-icon dark>mdi-pencil</v-icon>
                            </v-btn>
                          </template>
                          <span>Edit this purchase order (stock is updated too)</span>
                        </v-tooltip>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              v-bind="attrs"
                              v-on="on"
                              class="ml-2 my-auto"
                              fab
                              x-small
                              color="error"
                              @click.stop="confirmDeleteDraft(order)"
                            >
                              <v-icon dark>mdi-delete</v-icon>
                            </v-btn>
                          </template>
                          <span>Delete this purchase order</span>
                        </v-tooltip>
                        <!-- Less-used actions, to keep the row to View / Edit / Delete -->
                        <v-menu bottom left offset-y>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              v-bind="attrs"
                              v-on="on"
                              class="ml-1 my-auto"
                              icon
                              small
                              title="More actions"
                              @click.stop
                            >
                              <v-icon>mdi-dots-vertical</v-icon>
                            </v-btn>
                          </template>
                          <v-list dense>
                            <v-list-item :disabled="!orderBill(order) || downloadingId === order.id" @click="downloadInvoice(order)">
                              <v-list-item-icon class="mr-3"><v-icon small color="primary">mdi-file-download-outline</v-icon></v-list-item-icon>
                              <v-list-item-title>{{ orderBill(order) ? 'Download Invoice' : 'No bill raised yet' }}</v-list-item-title>
                            </v-list-item>
                            <v-list-item :disabled="order.payment_status === 'paid'" @click="openBalancePayment(order)">
                              <v-list-item-icon class="mr-3"><v-icon small color="success">mdi-cash-refund</v-icon></v-list-item-icon>
                              <v-list-item-title>{{ order.payment_status === 'paid' ? 'Already fully paid' : 'Record Balance Payment' }}</v-list-item-title>
                            </v-list-item>
                            <v-list-item
                              v-if="can('PURCHASE_RETURNS.CREATE')"
                              @click="$router.push(`/purchase-returns?purchase_order_id=${order.id}`)"
                            >
                              <v-list-item-icon class="mr-3"><v-icon small color="orange">mdi-keyboard-return</v-icon></v-list-item-icon>
                              <v-list-item-title>Return Items to Vendor</v-list-item-title>
                            </v-list-item>
                          </v-list>
                        </v-menu>
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr>
                      <td colspan="10">
                        <AppEmptyState
                          icon="mdi-truck-delivery-outline"
                          title="No purchase orders yet"
                          message="Create a purchase order to bring stock in from a vendor."
                          action-text="Create Purchase Order"
                          @action="openCreate"
                        />
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
              <v-pagination v-model="page" :length="paginationLength">
              </v-pagination>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <AppDialog
      :show.sync="showViewDialog"
      max-width="900"
      icon="mdi-truck-delivery-outline"
      :title="viewingOrder ? viewingOrder.po_number : ''"
      :subtitle="viewingOrder && viewingOrder.vendor ? viewingOrder.vendor.name : ''"
      :status-text="viewingOrder ? paymentStatusLabels[viewingOrder.payment_status] : ''"
      :status-color="viewingOrder ? paymentStatusColor(viewingOrder.payment_status) : 'grey'"
    >
      <PurchaseOrderViewPage
        v-if="showViewDialog"
        embedded
        :order-id="selectedOrderId"
        @saved="getData"
        @close="showViewDialog = false"
      />
    </AppDialog>

    <!-- Persistent on purpose: X, Esc and a click outside all go through
         requestCreateClose, which saves unfinished work as a draft first. -->
    <AppDialog
      :show="showCreateDialog"
      persistent
      max-width="1100"
      icon="mdi-truck-delivery-outline"
      :title="orderToEdit ? 'Edit Purchase Order' : draftToComplete ? 'Complete Draft Purchase Order' : 'Create Purchase Order'"
      :subtitle="orderToEdit ? orderToEdit.po_number + ' - changes update stock and the bill'
        : draftToComplete ? draftToComplete.po_number + ' - finish the details and place the order' : 'Order stock in from a vendor'"
      @close="requestCreateClose"
      @outside="requestCreateClose"
    >
      <PurchaseOrderCreatePage
        v-if="showCreateDialog"
        ref="createPo"
        embedded
        :draft-order-id="draftToComplete ? draftToComplete.id : null"
        :edit-order-id="orderToEdit ? orderToEdit.id : null"
        @saved="onCreateSaved"
        @draft-saved="onDraftSaved"
        @close="showCreateDialog = false"
      />
    </AppDialog>

    <!-- Delete a draft or a purchase order -->
    <v-dialog v-model="showDeleteDraft" max-width="460">
      <v-card v-if="draftToDelete">
        <v-card-title class="text-subtitle-1 font-weight-bold">
          {{ draftToDelete.is_draft ? "Delete this draft?" : `Delete ${draftToDelete.po_number}?` }}
        </v-card-title>
        <v-card-text v-if="draftToDelete.is_draft">
          Draft {{ draftToDelete.po_number }} will be removed. No stock or bill was created for it, so nothing else changes.
        </v-card-text>
        <v-card-text v-else-if="!deletePreview" class="text-center py-6">
          <v-progress-circular indeterminate color="primary" size="28"></v-progress-circular>
        </v-card-text>
        <v-card-text v-else-if="deletePreview.blocked">
          <v-alert type="warning" dense text class="mb-0">{{ deletePreview.blocked }}</v-alert>
        </v-card-text>
        <v-card-text v-else>
          <p class="mb-2">This will also delete:</p>
          <ul class="mb-3 delete-list">
            <li>The stock it brought in (taken back out of company stock)</li>
            <li v-for="bill in deletePreview.bills" :key="bill.bill_number">
              Bill <strong>{{ bill.bill_number }}</strong> (₹{{ money(bill.total_amount) }})
            </li>
            <li v-if="deletePreview.payments_count">
              {{ deletePreview.payments_count }} vendor payment{{ deletePreview.payments_count === 1 ? "" : "s" }}
              (₹{{ money(deletePreview.payments_amount) }})
            </li>
            <li v-if="deletePreview.products.length">
              {{ deletePreview.products.length === 1 ? "Product" : "Products" }} made for this purchase:
              <strong>{{ deletePreview.products.join(", ") }}</strong>
            </li>
          </ul>
          <p class="mb-2 grey--text text--darken-1">
            Products you already had stay, but selling prices changed by this purchase are not reverted.
          </p>
          <p class="mb-0 grey--text text--darken-1">You can restore it later - all of this comes back.</p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="showDeleteDraft = false">Cancel</v-btn>
          <v-btn
            color="error"
            depressed
            :loading="isDeletingDraft"
            :disabled="!draftToDelete.is_draft && (!deletePreview || !!deletePreview.blocked)"
            @click="deleteDraft"
          >
            Delete
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Balance Payment -->
    <v-dialog v-model="showBalancePaymentDialog" max-width="480" persistent>
      <v-card v-if="balancePaymentOrder">
        <v-card-title class="text-h6">
          Record Payment - {{ balancePaymentOrder.po_number }}
        </v-card-title>
        <v-card-text>
          <div class="d-flex justify-space-between mb-4">
            <div>
              <div class="text-caption grey--text">Order Total</div>
              <div class="font-weight-medium mono-figure">₹{{ balancePaymentOrder.total_amount }}</div>
            </div>
            <div class="text-right">
              <div class="text-caption grey--text">Pending Balance</div>
              <div class="font-weight-bold error--text mono-figure">₹{{ balancePaymentPending }}</div>
            </div>
          </div>
          <v-text-field
            v-model.number="balancePayment.amount"
            type="number"
            min="0.01"
            :max="balancePaymentPending"
            outlined
            dense
            :error-messages="balancePaymentErrors.initial_payment_amount"
          >
            <template v-slot:label>Amount <span style="color:#f44336;font-weight:bold;">*</span></template>
          </v-text-field>
          <v-select
            v-model="balancePayment.mode"
            :items="paymentModes"
            item-text="text"
            item-value="value"
            outlined
            dense
            :error-messages="balancePaymentErrors.initial_payment_mode"
          >
            <template v-slot:label>Payment Mode <span style="color:#f44336;font-weight:bold;">*</span></template>
          </v-select>
          <v-menu
            v-model="balancePaymentDateMenu"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="balancePayment.date"
                outlined
                dense
                readonly
                label="Payment Date"
                v-bind="attrs"
                v-on="on"
                :error-messages="balancePaymentErrors.initial_payment_date"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="balancePayment.date"
              @input="balancePaymentDateMenu = false"
            ></v-date-picker>
          </v-menu>
          <v-text-field
            v-model="balancePayment.reference"
            label="Reference (optional)"
            outlined
            dense
          ></v-text-field>
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn text @click="showBalancePaymentDialog = false" :disabled="isSavingPayment">Cancel</v-btn>
          <v-btn color="primary" :loading="isSavingPayment" @click="saveBalancePayment">Record Payment</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-main>
</template>

<script>
import axios from "axios";
import AppDialog from "@/components/AppDialog.vue";
import AppEmptyState from "@/components/AppEmptyState.vue";
import AppPageHeader from "@/components/AppPageHeader.vue";
import PurchaseOrderViewPage from "./view.vue";
import PurchaseOrderCreatePage from "./create.vue";
export default {
  name: "purchaseOrdersPage",
  components: { AppDialog, AppEmptyState, AppPageHeader, PurchaseOrderViewPage, PurchaseOrderCreatePage },
  data() {
    return {
      filter: {
        vendor_id: "",
        status: null,
      },
      statusOptions: [
        { text: "Draft", value: "draft" },
        { text: "Ordered", value: "ordered" },
      ],
      draftCount: 0,
      draftToComplete: null,
      orderToEdit: null,
      draftToDelete: null,
      showDeleteDraft: false,
      deletePreview: null,
      isDeletingDraft: false,
      page: 1,
      paginationLength: 0,
      count: 0,
      orders: [],
      vendors: [],
      isLoading: false,
      downloadingId: null,
      showViewDialog: false,
      selectedOrderId: null,
      viewingOrder: null,
      showCreateDialog: false,
      billingStatusLabels: {
        unbilled: "Unbilled",
        partially_billed: "Partially Billed",
        fully_billed: "Fully Billed",
      },
      paymentStatusLabels: {
        unpaid: "Unpaid",
        partial: "Partial",
        paid: "Paid",
      },
      // Balance Payment
      showBalancePaymentDialog: false,
      balancePaymentOrder: null,
      balancePaymentDateMenu: false,
      balancePayment: {
        amount: null,
        mode: null,
        date: new Date().toISOString().substr(0, 10),
        reference: "",
      },
      balancePaymentErrors: {},
      isSavingPayment: false,
      paymentModes: [
        { text: "Cash", value: 0 },
        { text: "Bank Transfer", value: 1 },
        { text: "Cheque", value: 2 },
        { text: "UPI", value: 3 },
        { text: "Other", value: 4 },
      ],
    };
  },
  computed: {
    balancePaymentPending() {
      if (!this.balancePaymentOrder) return "0.00";
      const bill = (this.balancePaymentOrder.bills || [])[0];
      return bill ? bill.pending_amount : this.balancePaymentOrder.total_amount;
    },
  },
  watch: {
    page: "getData",
  },
  mounted() {
    this.getData();
    this.getMasters();
  },
  methods: {
    viewOrder(order) {
      this.selectedOrderId = this.encryptIt(order.id);
      this.viewingOrder = order;
      this.showViewDialog = true;
    },
    // A PO always gets its bill raised at creation time (or via the
    // separate "Record Balance Payment" flow) - this is that bill, the one
    // an invoice can actually be generated from.
    orderBill(order) {
      return order.bills && order.bills.length ? order.bills[0] : null;
    },
    async downloadInvoice(order) {
      const bill = this.orderBill(order);
      if (!bill) return;
      this.downloadingId = order.id;
      try {
        const response = await axios.get(
          `/purchase_bills/${this.encryptIt(bill.id)}/invoice/download`,
          { responseType: "blob" }
        );
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `purchase_bill_${bill.bill_number}.pdf`);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.log(error);
      }
      this.downloadingId = null;
    },
    openCreate() {
      this.draftToComplete = null;
      this.orderToEdit = null;
      this.showCreateDialog = true;
    },
    // Open a saved draft in the same form to finish and place it
    openDraft(order) {
      this.draftToComplete = order;
      this.orderToEdit = null;
      this.showCreateDialog = true;
    },
    // Open a placed order in the same form to change it
    openEdit(order) {
      this.draftToComplete = null;
      this.orderToEdit = order;
      this.showCreateDialog = true;
    },
    showDrafts() {
      this.filter.status = "draft";
      this.page = 1;
      this.getData();
    },
    // X, Esc and a click outside the dialog all land here. The form keeps
    // unfinished work as a draft rather than losing it.
    async requestCreateClose() {
      const form = this.$refs.createPo;
      if (!form) {
        this.showCreateDialog = false;
        return;
      }
      const result = await form.requestClose();
      if (!result.close) {
        return;
      }
      this.showCreateDialog = false;
      if (result.savedDraft) {
        this.onDraftSaved();
      }
    },
    onDraftSaved() {
      this.showCreateDialog = false;
      this.getData();
      if (this.$toast) {
        this.$toast.info("Saved as a draft - finish it any time from the Draft filter.");
      }
    },
    onCreateSaved() {
      this.showCreateDialog = false;
      this.getData();
      if (this.$toast) {
        this.$toast.success(
          this.orderToEdit ? `${this.orderToEdit.po_number} updated - stock adjusted`
            : this.draftToComplete ? "Draft completed - purchase order placed" : "Purchase Order created successfully"
        );
      }
    },
    async confirmDeleteDraft(order) {
      this.draftToDelete = order;
      this.deletePreview = null;
      this.showDeleteDraft = true;
      if (order.is_draft) return;
      // What goes with it (bills, payments, products) - shown before deleting
      try {
        const response = await axios.get(`/purchase_orders/delete_preview/${this.encryptIt(order.id)}`);
        if (this.draftToDelete === order) this.deletePreview = response.data.data;
      } catch (error) {
        console.log(error);
        this.showDeleteDraft = false;
        if (this.$toast) this.$toast.error("Could not load the purchase order.");
      }
    },
    money(value) {
      return (Number(value) || 0).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    },
    async deleteDraft() {
      this.isDeletingDraft = true;
      try {
        await axios.post(`/purchase_orders/delete/${this.encryptIt(this.draftToDelete.id)}`);
        this.showDeleteDraft = false;
        if (this.$toast && !this.draftToDelete.is_draft) this.$toast.success(`${this.draftToDelete.po_number} deleted.`);
        this.getData();
      } catch (error) {
        console.log(error);
        // e.g. bills or vendor returns raised against it in the meantime
        const message = error.response && error.response.data && error.response.data.message;
        if (this.$toast) this.$toast.error(message || "Could not delete the purchase order.");
      }
      this.isDeletingDraft = false;
    },
    billingStatusColor(status) {
      const colors = {
        unbilled: "grey",
        partially_billed: "warning",
        fully_billed: "info",
      };
      return colors[status] || "grey";
    },
    paymentStatusColor(status) {
      const colors = {
        unpaid: "error",
        partial: "warning",
        paid: "success",
      };
      return colors[status] || "grey";
    },
    async getMasters() {
      await axios
        .get(`masters?context=purchase_order`)
        .then((response) => {
          this.vendors = response.data.vendors || [];
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    async getData() {
      this.isLoading = true;
      this.filter.vendor_id = this.filter.vendor_id
        ? this.filter.vendor_id
        : "";
      let query =
        "page=" +
        this.page +
        "&rowsPerPage=" +
        this.rowsPerPage +
        "&vendor_id=" +
        this.filter.vendor_id +
        "&status=" +
        (this.filter.status || "") +
        "&search_keyword=" +
        (this.filter.search_keyword || "");
      await axios
        .get(`purchase_orders?${query}`)
        .then((response) => {
          this.orders = response.data.data;
          this.count = response.data.count;
          this.draftCount = response.data.draft_count || 0;
          this.paginationLength = Math.ceil(this.count / this.rowsPerPage);
        })
        .catch(function (error) {
          console.log(error);
        });
      this.isLoading = false;
    },
    openBalancePayment(order) {
      this.balancePaymentOrder = order;
      this.balancePayment = {
        amount: null,
        mode: null,
        date: new Date().toISOString().substr(0, 10),
        reference: "",
      };
      this.balancePaymentErrors = {};
      this.showBalancePaymentDialog = true;
    },
    async saveBalancePayment() {
      this.balancePaymentErrors = {};
      if (!this.balancePayment.amount || this.balancePayment.amount <= 0) {
        this.balancePaymentErrors = { initial_payment_amount: ["Amount is required."] };
        return;
      }
      if (!this.balancePayment.mode && this.balancePayment.mode !== 0) {
        this.balancePaymentErrors = { initial_payment_mode: ["Payment mode is required."] };
        return;
      }

      this.isSavingPayment = true;
      try {
        await axios.post("/purchase_bills", {
          purchase_order_id: this.balancePaymentOrder.id,
          bill_date: this.balancePaymentOrder.po_date,
          initial_payment_amount: this.balancePayment.amount,
          initial_payment_date: this.balancePayment.date,
          initial_payment_mode: this.balancePayment.mode,
          initial_payment_reference: this.balancePayment.reference || null,
        });
        this.showBalancePaymentDialog = false;
        this.getData();
      } catch (e) {
        console.log(e);
        if (e.response && e.response.data && e.response.data.errors) {
          this.balancePaymentErrors = e.response.data.errors;
        } else if (e.response && e.response.data && e.response.data.message) {
          this.balancePaymentErrors = { initial_payment_amount: [e.response.data.message] };
        }
      } finally {
        this.isSavingPayment = false;
      }
    },
    async Delete_this(id) {
      await axios
        .post(`/purchase_orders/delete/${this.encryptIt(id)}`)
        .then(() => {
          this.getData();
        })
        .catch(function (error) {
          console.log(error);
        });
    },
  },
};
</script>

<style scoped>
.delete-list li {
  margin-bottom: 4px;
}
.draft-banner {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 12px 16px;
  border-radius: 8px;
  background: #fae8dd;
}
.draft-banner__icon {
  width: 30px;
  height: 30px;
  border-radius: 7px;
  background: #ffa24b;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.draft-banner__text {
  color: #f08a24;
  font-weight: 500;
}
.clickable-row {
  cursor: pointer;
}
.clickable-row:hover > td {
  background-color: #FBF7EF !important;
}
</style>
